import { Button } from 'components/Button';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { paths } from 'routes';
import { Asset } from 'types/Asset';
import assetClassesWithFundStructures from 'utils/assetClassesWithFundStructures';

type Props = {
  // eslint-disable-next-line no-unused-vars
  onSaveUpload: () => void;
  name?: string;
  initialName?: string;
  nameIsAvailable: boolean;
  assets: Asset[];
  dirty: boolean;
};

const Buttons: React.FC<Props> = ({
  name,
  initialName,
  nameIsAvailable,
  onSaveUpload,
  assets,
  dirty,
}: Props) => {
  const [showConfirmCancel, setShowConfirmCancel] = useState<boolean>(false);

  const history = useHistory();

  const canSave = () => {
    return (
      name && name.length > 0 && (nameIsAvailable || name === initialName) && assetsIsCompete()
    );
  };

  const assetsIsCompete = () => {
    // TODO: can be optimized, no need to check length of strings
    // If we can do "row editing" we should evaluate this per row item.

    return (
      assets.length > 0 &&
      !assets.some(
        (asset) =>
          !asset.resourceId ||
          !asset.firmName ||
          asset.firmName.length === 0 ||
          !asset.productName ||
          asset.productName.length === 0 ||
          !asset.performanceFrequency ||
          asset.performanceFrequency.length === 0 ||
          !asset.assetClassId ||
          asset.assetClassId === 0 ||
          !asset.investmentFocusId ||
          asset.investmentFocusId === 0 ||
          !asset.currencyCode ||
          asset.currencyCode.length === 0 ||
          !asset.reportingMethodId ||
          asset.reportingMethodId === 0 ||
          (assetClassesWithFundStructures.includes(asset.assetClassId)
            ? !asset.fundStructureId || asset.fundStructureId === 0
            : !!asset.fundStructureId && asset.fundStructureId !== 0) ||
          !asset.geographicFocusId ||
          asset.geographicFocusId === 0 ||
          !asset.vehicleTypeId ||
          asset.vehicleTypeId === 0,
      )
    );
  };

  const cancel = () => history.push(paths.productUploads);

  const ConfirmCancel: React.FC<{}> = () => (
    <ConfirmModal
      show={showConfirmCancel}
      onClose={() => {
        setShowConfirmCancel(false);
      }}
      onConfirm={() => {
        cancel();
        setShowConfirmCancel(false);
      }}
      title="Cancel"
      message="Your unsaved changes will be discarded. Are you sure you wish to proceed?"
    />
  );

  const handleCancel = () => {
    if (dirty) {
      setShowConfirmCancel(true);
    } else {
      cancel();
    }
  };

  return (
    <>
      <ConfirmCancel />
      <div className="text-right fixed-bottom p-3" style={{ backgroundColor: '#E8EDF2' }}>
        <Button className={'mr-2'} variant={'semitransparent'} onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant={'primary'} onClick={onSaveUpload} disabled={!canSave()}>
          Upload
        </Button>
      </div>
    </>
  );
};

export default Buttons;
